import { render, staticRenderFns } from "./CustomerSaleAndReturn.vue?vue&type=template&id=cd3fbca8&"
import script from "./CustomerSaleAndReturn.vue?vue&type=script&lang=js&"
export * from "./CustomerSaleAndReturn.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSaleAndReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports